import { useMemo } from "react";
import { useSelector } from "react-redux";
import { paginatedEquipmentSelector } from "Venues/state";
import { getEquipmentKey, usePagination } from "Venues/utils";

export const useSelectVenueEquipment = (venueId: string) => {
  const paginationKey = useMemo(() => getEquipmentKey(venueId), [venueId]);
  const pagination = usePagination(paginationKey);
  const equipment = useSelector(paginatedEquipmentSelector(pagination));

  return { paginationKey, pagination, equipment };
};
